import { useDismissBannerMessage } from '@hooks/useBannerMessages'
import { Banner } from 'components/notifications'
import { FC } from 'react'
import { Markdown } from 'components/markdown'
import { useModal } from '@hooks/useModal'
import { useTranslation } from 'react-i18next'

interface Props {
  message: BannerMessage
}

export const BannerMessage: FC<Props> = ({ message }) => {
  const dismissBannerMessage = useDismissBannerMessage()
  const modal = useModal()
  const { t } = useTranslation()

  const readMore = () => {
    const id = modal.open({
      title: message.title,
      closeOnBackgroundClick: true,
      variant: 'custom',
      content: (
        <div>
          <div className="px-5 max-w-2xl">
            <Markdown>{message.longBody}</Markdown>
          </div>
          <div className="mt-5 p-5 font-medium text-sm border-t border-neutral-300 flex gap-2 justify-end">
            <a
              onClick={() => {
                dismissBannerMessage.mutate(message.id)
                modal.close(id)
              }}
              className="cursor-pointer text-neutral-500"
            >
              {t('components.bannerMessages.permanentlyDismiss')}
            </a>
          </div>
        </div>
      ),
      onClose: () => modal.close(id),
    })
  }

  return (
    <Banner
      content={
        <div className="flex flex-row items-center gap-2">
          <Markdown>{message.shortBody}</Markdown>
          {message.longBody && (
            <a
              className="cursor-pointer text-hyperlink-blue"
              onClick={readMore}
            >
              {t('components.bannerMessages.readMore')}
            </a>
          )}
        </div>
      }
      dismissable={true}
      title={message.title}
      variant={message.style}
      onCloseButtonClick={() => dismissBannerMessage.mutate(message.id)}
    />
  )
}
